import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './estoqueForm';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import { 
	setModoTela, initForm, salvar, excluir, 
	getLista, getListaProduto, getListaUnidade
} from './estoqueActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import Select from '../common/form/select';

class Estoque extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: '',
		dataInicial: DateFormat.formatarDataSqlParaTela(DateFormat.getTimestampParaData(new Date().getTime() - 604800000)),
		dataFinal: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaProduto();
		this.props.getListaUnidade();

		let idInterval = setInterval(() => {
			this.props.getLista();
			this.props.getListaProduto();
			this.props.getListaUnidade();
		}, 60000);
		
		this.setState({
			...this.state,
			idInterval: idInterval
		});
	}
	
	componentWillUnmount() {

		if (this.state.idInterval) {
			clearInterval(this.state.idInterval);
		}
	
	}

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let saldoCalculado = 0;
		let lista = this.props.lista.filter(item => {
			if (!this.state.id_unidade || item.id_unidade != this.state.id_unidade) {
				return false;
			}
			if (!this.state.id_produto || item.id_produto != this.state.id_produto) {
				return false;
			}
			return true;
		}).map(item => {
			const saldoInicial = saldoCalculado;
			//Começa a contar com esse estoque a partir daqui - se houver alterações anteriores não irá aplicar daqui para frente
			if (item.nome_tipo == 'Ajuste de Saldo') {
				saldoCalculado = parseFloat(item.quantidade_estoque);
			} else {
				saldoCalculado += parseFloat(item.quantidade_estoque);
			}

			return {
				...item,
				saldo_inicial: item.nome_tipo == 'Ajuste de Saldo' ? null : saldoInicial,
				saldo_final: saldoCalculado,
				quantidade: item.nome_tipo == 'Ajuste de Saldo' ? null : item.quantidade
			}
		}).filter(item => {
			if (this.state.dataInicial
				&& DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.datahora_estoque)) < DateFormat.formatarDataTelaParaSql(this.state.dataInicial)) {
				return false;
			}
			if (this.state.dataFinal
				&& DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.datahora_estoque)) > DateFormat.formatarDataTelaParaSql(this.state.dataFinal)) {
				return false;
			}
			return true;
		});
	
		/* Janiel, Pedro, Artur Gonçalves Rodrigues */
		const edicao = this.props.usuarioCarregado && this.props.usuarioCarregado.ajuste_saldo;

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						{edicao &&
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({
										datahora_estoque: DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual()),
										id_unidade: this.state.id_unidade,
										id_produto: this.state.id_produto
									});
								}} />
						</Grid>}
						<Grid cols='6 6 4 2'>
							<Button
								text='Atualizar'
								type={'primary'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.getLista();
								}} />
						</Grid>
						<Grid cols='6 6 3 2'>
							<ExcelFile
								filename={'Estoque'}
								element={
									<Button
									text='Exportar'
									type={'primary'}
									icon={'fa fa-plus'} />
								}>
								<ExcelSheet data={lista.map(item => ({
									...item,
									datahora_estoque: DateFormat.formatarDataHoraSqlParaTela(item.datahora_estoque),
									saldo_inicial: FormatUtils.formatarValorTelaDecimal(item.saldo_inicial, 2),
									quantidade: FormatUtils.formatarValorTelaDecimal(item.quantidade, 2),
									saldo_final: FormatUtils.formatarValorTelaDecimal(item.saldo_final, 2),
									datahora_petroshow: DateFormat.formatarDataHoraSqlParaTela(item.datahora_petroshow),
									quantidade_petroshow: FormatUtils.formatarValorTelaDecimal(item.quantidade_petroshow, 2),
									diferenca_petroshow:  item.datahora_petroshow 
										? FormatUtils.formatarValorTelaDecimal(parseFloat(item.saldo_final || 0) - parseFloat(item.quantidade_petroshow || 0), 2)
										: null
								}))} name='Estoque'>
									<ExcelColumn label='Data Hora' value='datahora_estoque' />
									<ExcelColumn label='Placa' value='placa_veiculo' />
									<ExcelColumn label='Tipo' value='nome_tipo' />
									<ExcelColumn label='Controle' value='numero_controle' />
									<ExcelColumn label='Saldo Inicial' value='saldo_inicial' />
									<ExcelColumn label='Operação' value='operacao' />
									<ExcelColumn label='Quantidade' value='quantidade' />
									<ExcelColumn label='Saldo Final' value='saldo_final' />
									<ExcelColumn label='Atualização Petroshow' value='datahora_petroshow' />
									<ExcelColumn label='Petroshow' value='quantidade_petroshow' />
									<ExcelColumn label='Diferença' value='diferenca_petroshow' />
								</ExcelSheet>
							</ExcelFile>
						</Grid>
					</Row>

				</ContentCardHeader>
				<ContentCardBody>

					<Row>
						<Select
							label='Unidade' placeholder='Selecione a unidade'
							cols='6 6 4 2'
							options={this.props.listaUnidade}
							value={this.state.id_unidade}
							onChange={value => {
								this.setState({ 
									...this.state, 
									id_unidade: value 
								});
							}} />

						<Select
							label='Produto' placeholder='Selecione o produto'
							cols='6 6 4 2'
							options={this.props.listaProduto}
							value={this.state.id_produto}
							onChange={value => {
								this.setState({ 
									...this.state, 
									id_produto: value 
								});
							}} />

						<LabelAndInputMask
							name='data_inicial'
							label='Data Inicial' placeholder='Informe a data'
							cols='12 6 2 2'
							mask='99/99/9999'
							value={this.state.dataInicial}
							onChange={data => {
								this.setState({
									...this.state,
									dataInicial: data.target.value
								});
							}} />

						<LabelAndInputMask
							name='data_final'
							label='Data Final' placeholder='Informe a data'
							cols='12 6 2 2'
							mask='99/99/9999'
							value={this.state.dataFinal}
							onChange={data => {
								this.setState({
									...this.state,
									dataFinal: data.target.value
								});
							}} />
					</Row>
					<Table responsive>
						<THead>
							<Tr>
								<Th colspan={1} alignCenter>Data Hora</Th>
								<Th colspan={1} alignCenter>Placa</Th>
								<Th colspan={1} alignCenter>Tipo</Th>
								<Th colspan={1} alignCenter>Controle</Th>
								<Th colspan={1} alignRight>Saldo Inicial</Th>
								<Th colspan={2} alignRight>Quantidade</Th>
								<Th colspan={1} alignRight>Saldo Final</Th>
								<Th colspan={1} alignRight>Petroshow</Th>
								<Th colspan={1} alignRight>Diferença</Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => {

								const diferencaPetroshow = item.datahora_petroshow 
									? parseFloat(item.saldo_final || 0) - parseFloat(item.quantidade_petroshow || 0)
									: null;

								return (
									<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
										onClick={() => this.setState({ linhaSelecionada: item.id })}
										onMouseEnter={() => this.setState({ linhaSelecionada: item.id })} >
										<Td width={150} alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_estoque)}</Td>
										<Td width={10} alignCenter>{item.placa_veiculo}</Td>
										<Td width={400} alignCenter>{item.numero_controle}</Td>
										<Td width={150} alignCenter>
											{item.nome_tipo}
											{(item.nome_tipo == 'Entrada por Quebra' || item.nome_tipo == 'Saída por Quebra' || item.nome_tipo == 'Ajuste de Saldo') &&
											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={edicao}
												small
												event={() => {
													this.props.setModoTela('cadastro', {
														...item,
														datahora_estoque: DateFormat.formatarDataHoraSqlParaTela(item.datahora_estoque),
														quantidade: FormatUtils.formatarValorTela(item.quantidade, 2)
													});
													this.props.initForm({
														...item,
														datahora_estoque: DateFormat.formatarDataHoraSqlParaTela(item.datahora_estoque),
														quantidade: FormatUtils.formatarValorTela(item.quantidade, 2)
													});
												}} />}
											{(item.nome_tipo == 'Entrada por Quebra' || item.nome_tipo == 'Saída por Quebra' || item.nome_tipo == 'Ajuste de Saldo') &&
											<ButtonTable
												type={'danger'}
												icon={'fas fa-trash-alt'}
												visible={edicao}
												small
												event={() => {
													this.props.setModoTela('exclusao', {
														...item,
														datahora_estoque: DateFormat.formatarDataHoraSqlParaTela(item.datahora_estoque),
														quantidade: FormatUtils.formatarValorTela(item.quantidade, 2)
													});
													this.props.initForm({
														...item,
														datahora_estoque: DateFormat.formatarDataHoraSqlParaTela(item.datahora_estoque),
														quantidade: FormatUtils.formatarValorTela(item.quantidade, 2)
													});
												}} />}
										</Td>
										<Td width={150} alignRight>{item.nome_tipo == 'Ajuste de Saldo' ? '' : FormatUtils.formatarValorTelaDecimal(item.saldo_inicial, 2)}</Td>
										<Td width={150} alignCenter>
											{item.operacao == '-' ? (
												<i style={{ color: '#ff0000' }} class='fas fa-minus'></i>
											) : (item.operacao == '+' ? (
												<i style={{ color: '#000dbd' }} class='fas fa-plus'></i>
											) : (
												<i style={{ color: '#035900' }} class='fas fa-pencil-ruler'></i>
											))}
										</Td>
										<Td width={10} alignRight>{item.nome_tipo == 'Ajuste de Saldo' ? '' : FormatUtils.formatarValorTelaDecimal(item.quantidade, 2)}</Td>
										<Td width={150} alignRight>{FormatUtils.formatarValorTelaDecimal(item.saldo_final, 2)}</Td>
										<Td width={150} alignRight 
											title={item.datahora_petroshow ? `Atualizado: ${DateFormat.formatarDataHoraSqlParaTela(item.datahora_petroshow)}` : 'Não Informadp'}>
											{item.datahora_petroshow ? FormatUtils.formatarValorTelaDecimal(item.quantidade_petroshow, 2) : '-'}
										</Td>
										<Td width={150} alignRight>{diferencaPetroshow == null ? '-' : FormatUtils.formatarValorTelaDecimal(diferencaPetroshow, 2)}</Td>
									</Tr>
								)
							})}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	modalBaseVisualizacao() {

		if (!this.state.modalBaseVisualizacao) {
			return null;
		}
		
		const registro = { ...this.state.modalBaseVisualizacao };

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Processo de Descarga na Base</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, modalBaseVisualizacao: null, zoom: 100 })}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ maxHeight: window.innerHeight - 200, overflowY: 'scroll' }}>

							
								
						</div>
						<div class=''>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
						</div>
					</div>
				</div>
			</div>
        );
    }

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	modoTela: state.estoque.modoTela,
	lista: state.estoque.lista,
    listaUnidade: state.estoque.listaUnidade,
    listaProduto: state.estoque.listaProduto
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, 
	getLista, getListaProduto, getListaUnidade
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Estoque);
